
export class FightIdentFF {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Fight Ident FF";
    this.scene = "Fight Ident FF";
    this.data = [];
    this.page = 621;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "110";
      }).value = (options?.game?.home_fighter?.last_name?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "120";
      }).value = (options?.game?.away_fighter?.last_name?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "P2002";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.away_fighter?.image || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "P2001";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.home_fighter?.image || "");

      
      xml.payload.field.find((item) => {
        return item.attr.name === "001";
      }).value = (options?.game?.number_of_rounds || "") + " ROUNDS " + (options?.game?.title || "");

      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
